import {
    CustomItemRendererType,
    FormObject,
    FormStructure,
} from '@europrocurement/flexy-form/components';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { jsonSubForm, visibilityType } from '../types/formTypes';
import jsonSubformArrayToStructure from './jsonSubformArrayToStructure';
// eslint-disable-next-line import/no-cycle
import jsonPageSectionToStructure from './jsonPageSectionToStructure';
import { checkFieldValue } from '../functions';

const jsonSubformToStructure: (
    subForm: jsonSubForm,
    customItemRenderer: CustomItemRendererType,
    visibility?: visibilityType,
) => FormStructure = (subform, customItemRenderer, visibility) => {
    const { minlength = 0, maxlength = Infinity, rules, sections, ...base } = subform;

    if (!(minlength === 1 && maxlength === 1)) {
        return jsonSubformArrayToStructure(subform);
    }

    const subForm: FormStructure = {
        ...base,
        type: 'subform',
        defaultLength: 1,
        minLength: 1,
        maxLength: 1,
        structure: sections.map((section) =>
            jsonPageSectionToStructure(section, customItemRenderer, visibility),
        ),
    };

    // comportement sur rules display
    if (rules && rules.display) {
        if (rules.display.fieldIsEqualTo) {
            if (Array.isArray(rules.display.fieldIsEqualTo)) {
                subForm.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                    rules.display.fieldIsEqualTo.every((item: fieldEqualityType) => {
                        const { field, value } = item;
                        return checkFieldValue(formContext, value, field);
                    });
            } else {
                const fieldNameToWatch = rules.display.fieldIsEqualTo.field;
                const valueToWatch = rules.display.fieldIsEqualTo.value;

                subForm.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                    checkFieldValue(formContext, valueToWatch, fieldNameToWatch);
            }
        }
        if (rules.display.fieldIsNotEqualTo) {
            const fieldNameToWatch = rules.display.fieldIsNotEqualTo.field;
            const valueToWatch = String(rules.display.fieldIsNotEqualTo.value);

            subForm.display = (formContext: UseFormReturn<FieldValues, FormObject>) => {
                const valueWatch: string = formContext.watch(fieldNameToWatch as string)?.value;

                return Array.isArray(valueToWatch)
                    ? !valueToWatch.includes(valueWatch)
                    : valueWatch !== valueToWatch;
            };
        }
        if (rules.display.fieldIsChecked) {
            const fieldNameToWatch = rules.display.fieldIsChecked;

            subForm.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, true, fieldNameToWatch);
        }
        if (rules.display.fieldIsNotChecked) {
            const fieldNameToWatch = rules.display.fieldIsNotChecked;

            subForm.display = (formContext: UseFormReturn<FieldValues, FormObject>) =>
                checkFieldValue(formContext, false, fieldNameToWatch);
        }
    }

    return subForm;
};

export default jsonSubformToStructure;
